import React, { useContext } from 'react';
import { ThemeContext } from 'grommet';
import { normalizeColor } from 'grommet/utils';
import { Bar, BarChart, Cell, Line, LineChart, ReferenceLine, ResponsiveContainer, YAxis } from 'recharts';

// Every tile's picture is this tall, so the text above starts on the same line in each
export const SPARK_HEIGHT = 36;

// A tile's small picture: no axes, no hover, just the shape. `bars` lights the last one, the week
// the tile is about. `reference` is a dashed level to read the line against, such as the terms.
const Sparkline = ({ values, kind = 'line', reference }) => {
    const theme = useContext(ThemeContext);
    const color = (name) => normalizeColor(name, theme);
    const data = values.map((value) => ({ value }));
    if (data.length < 2) return <div style={{ height: SPARK_HEIGHT }} />;
    return (
        <ResponsiveContainer width="100%" height={SPARK_HEIGHT}>
            {kind === 'bars' ? (
                <BarChart data={data} barCategoryGap={2} margin={{ top: 2, right: 0, bottom: 0, left: 0 }}>
                    <Bar dataKey="value" isAnimationActive={false} radius={[2, 2, 0, 0]} minPointSize={2}>
                        {data.map((point, index) => (
                            <Cell key={index} fill={color(index === data.length - 1 ? 'barchart-primary' : 'chart-muted')} />
                        ))}
                    </Bar>
                </BarChart>
            ) : (
                <LineChart data={data} margin={{ top: 4, right: 4, bottom: 4, left: 4 }}>
                    <YAxis hide domain={[(min) => Math.min(min, reference ?? min), (max) => Math.max(max, reference ?? max)]} />
                    {reference > 0 && <ReferenceLine y={reference} stroke={color('text-weak')} strokeDasharray="3 3" />}
                    <Line dataKey="value" stroke={color('barchart-primary')} strokeWidth={2} dot={false} connectNulls isAnimationActive={false} />
                </LineChart>
            )}
        </ResponsiveContainer>
    );
};

// The receivables tile's picture: one thin bar split by age, in the donut's colors
export const SegmentSpark = ({ segments }) => {
    const theme = useContext(ThemeContext);
    const total = segments.reduce((sum, segment) => sum + segment.value, 0);
    return (
        <div style={{ height: SPARK_HEIGHT, display: 'flex', alignItems: 'center' }}>
            {total > 0 && (
                <div style={{ display: 'flex', gap: 2, height: 8, width: '100%' }}>
                    {segments.filter((segment) => segment.value > 0).map((segment) => (
                        <div key={segment.key} style={{ flex: segment.value / total, borderRadius: 2, background: normalizeColor(segment.color, theme) }} />
                    ))}
                </div>
            )}
        </div>
    );
};

export default Sparkline;
